import { Title, desktopFirstMediaQuery } from '@inflearn/ds-react';
import type { ParseKeys } from 'i18next';
import type { ReactNode } from 'react';

import { MyGiftsTabs } from './MyGiftsTabs';

import { useTranslation } from 'react-i18next';
import MyPageLayout from './index';

type MyGiftsLayoutProps = {
  children: ReactNode;
  pathname: string;
  description: ParseKeys;
  title: ParseKeys;
  isDetail?: boolean;
};

export function MyGiftsLayout({
  title,
  children,
  description,
  isDetail = false,
}: MyGiftsLayoutProps) {
  const { t } = useTranslation();

  return (
    <MyPageLayout
      meta={{
        title,
        description,
      }}
    >
      {!isDetail && (
        <>
          <Title
            order={2}
            mb={8}
            css={{
              [desktopFirstMediaQuery.mobile]: {
                fontSize: 22,
              },
            }}
          >
            {t('마이페이지_LNB_선물함')}
          </Title>
          <MyGiftsTabs />
        </>
      )}
      {children}
    </MyPageLayout>
  );
}
